import { mapGetters } from 'vuex';
import format from '../../../common/utilities/format';
const iconMap = {
    mediansize: 'icon-size',
    medianlistprice: 'icon-dollar-circle',
    medianpricepersqft: 'icon-money-sqft',
    inventory: 'icon-property-single-family',
    mediandom: 'icon-calendar-hole',
};

const keyMap = {
    mediansize: 'Avg. home size',
    medianlistprice: 'Avg. list price',
    medianpricepersqft: 'Avg. price/sqft',
    inventory: 'Homes for sale',
    mediandom: 'Avg. days on market',
};

function valueMap(id, value) {
    if (id === 'mediansize') {
        return `${format.formatNumberByComma(value)} Sqft`;
    }
    if (id === 'medianlistprice') {
        return `$${format.friendlyPrice(value)}`;
    }
    if (id === 'medianpricepersqft') {
        return `$${format.formatNumberByComma(value)}/Sqft`;
    }
    if (id === 'inventory') {
        return `${format.formatNumberByComma(value)}`;
    }
    if (id === 'mediandom') {
        return `${value} Days`;
    }
    return '';
}

export default {
    name: 'searchMarketTrends',
    inject: ['$eventBus'],
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('msp', ['msp', 'getGeoDisplayText']),
        marketTrendsSummary() {
            let data = [];
            if (this.msp.marketTrendsSummary && this.msp.marketTrendsSummary.length) {
                let allSummary = this.msp.marketTrendsSummary.find((snap) => snap.type === 'all');
                if (allSummary && allSummary.marketSnapShot && allSummary.marketSnapShot.length) {
                    data = allSummary.marketSnapShot.reduce((acc, next) => {
                        if (next && next.rawValue > 0 && next.id) {
                            acc.push({
                                icon: iconMap[next.id] || 'icon-size',
                                value: valueMap(next.id, next.rawValue),
                                key: keyMap[next.id],
                            });
                        }

                        return acc;
                    }, []);
                }
            }
            return data;
        },
    },
    data() {
        return {
            currentDate: new Date(),
        };
    },
};
